"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.semanticElementMixin = void 0;
/** @mixin semanticElementMixin */
/**
 * Adds styling for semantic elements when using the `as` prop.
 *
 * @example
 * import { semanticElementMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${semanticElementMixin}
 * `;
 *
 * <Component as="strong">My strong component</Component>
 * <Component as="em">My emphasis component</Component>
 *
 * @method
 * @param {object} [props]
 * @param {"em" | "i" | "strong" | "b"} [props.as] - A semantic text element
 * @return {CSSObject}
 */
var semanticElementMixin = function semanticElementMixin(props) {
  var as = props.as;
  if (as === 'em' || as === 'i') {
    return 'font-style: italic;';
  }
  if (as === 'strong' || as === 'b') {
    return 'font-weight: 700;';
  }
  return '';
};
exports.semanticElementMixin = semanticElementMixin;